"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var constants_1 = __importDefault(require("./constants"));
/**
 * @description React Hook checking if there is an ongoing incident in application dependencies
 * @param dependencies
 * Array of components that this app depends on
 * @param pollingRate
 * A number to designate the polling rate (optional) (default of 10 000ms)
 * @returns
 * Whether there is an ongoing incident in one of the dependencies
 */
var useCheckDisruption = function (dependencies, pollingRate) {
    if (pollingRate === void 0) { pollingRate = 10000; }
    var _a = (0, react_1.useState)(false), existsDisruption = _a[0], setExistsDisruption = _a[1];
    (0, react_1.useEffect)(function () {
        var checkDependencyDisruption = function () { return __awaiter(void 0, void 0, void 0, function () {
            var isDisruptionFound, unresolvedIncidentsResponse, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isDisruptionFound = false;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetch("".concat(constants_1.default.STATUS_PAGE_API, "/incidents/unresolved.json"), {
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                            })
                                .then(function (res) { return res.json(); })
                                .then(function (json) { return json.incidents; })];
                    case 2:
                        unresolvedIncidentsResponse = (_a.sent());
                        unresolvedIncidentsResponse.forEach(function (incident) {
                            incident.components &&
                                incident.components.forEach(function (component) {
                                    dependencies.forEach(function (dep) {
                                        if (dep === component.name) {
                                            setExistsDisruption(true);
                                            isDisruptionFound = true;
                                        }
                                    });
                                });
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        console.error('Statuspage.io fetch error: ', err_1);
                        setExistsDisruption(false);
                        return [3 /*break*/, 4];
                    case 4:
                        if (!isDisruptionFound) {
                            setExistsDisruption(false);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        checkDependencyDisruption();
        var intervalId = setInterval(function () { return checkDependencyDisruption(); }, pollingRate);
        return function () { return clearInterval(intervalId); };
    }, []);
    return existsDisruption;
};
exports.default = useCheckDisruption;
